/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Spaces_Create_DataInputs */



/**
* | output |
* | --- |
* | "Create knowledge spaces" |
*
* @param {Rights_Cap_Spaces_Create_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_spaces_create_data = /** @type {((inputs?: Rights_Cap_Spaces_Create_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Spaces_Create_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wissensräume erstellen")
	return /** @type {LocalizedString} */ ("Create knowledge spaces")
});